/* eslint-disable import/prefer-default-export */
export const FETCH_RETAILER_SMS_LOGS = 'FETCH_RETAILER_SMS_LOGS';
export const GET_ACTIVE_AMBASSADORS = 'GET_ACTIVE_AMBASSADORS';
export const UPDATE_AMBASSADORS_STATUS = 'UPDATE_AMBASSADORS_STATUS';
export const GET_EXPRESSWIFI_CUSTOMERS = 'GET_EXPRESSWIFI_CUSTOMERS';
export const SEARCH_EXPRESSWIFI_CUSTOMERS = 'SEARCH_EXPRESSWIFI_CUSTOMERS';
export const GET_EXPRESSWIFI_RETAILERS = 'GET_EXPRESSWIFI_RETAILERS';
export const GET_XWF_RETAILER_COMMENTS = 'GET_XWF_RETAILER_COMMENTS';
export const SEARCH_EXPRESSWIFI_RETAILERS = 'SEARCH_EXPRESSWIFI_RETAILERS';
